import axios, { AxiosError, AxiosResponse } from "axios";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ttProtectionUrls } from "../../../URL/ApplicationUrls";
import { TTProtection } from "../TTProtection";

export const useUpdateTTProtectionAsNewVersion = (ttProtectionId: number | string | undefined) => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (ttProtection: TTProtection) => {
      return axios.put(
        ttProtectionUrls.updateTTProtectionWithNewVersionApiUrl(ttProtectionId),
        ttProtection
      );
    },
    onSuccess: async (response: AxiosResponse) => {
      navigate(ttProtectionUrls.detailsFor(response.data));
      toast.success(`The TT Protection with the P-Nr. ${response.data} has been created`);
    },
    onError: (error: AxiosError) => {
      toast.error(error.response?.data);
    },
  });
};
